import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  connect() {
    this.initNewView();
    this.lanzarEventoCargado();
  }

  initNewView() {
    const nombre = this.element.querySelector('#grupo_nombre');
    const etiqueta = this.element.querySelector('#grupo_etiqueta');
    const selector = this.element.querySelector('#filtro_grupos');

    const actualizarEtiqueta = () => {
      const grupo = nombre.value;
      let etiquetaStr = `${(this.pathActual[3] || {}).nombre} ${grupo} ${(this.pathActual[1] || {}).abbr} ${(this.pathActual[4] || {}).nombre}`;
      etiquetaStr = etiquetaStr.replace(/undefined/g, '').trim();
      etiqueta.value = etiquetaStr;
    };

    selector.addEventListener('change', (e) => {
      this.pathActual = e.detail.path;
      actualizarEtiqueta();
    });
    nombre.addEventListener('keyup', actualizarEtiqueta);
  }
}
